import {
  FinancialCockpitPendingActionPriority,
  type IFinancialCockpitPendingAction,
} from '../../api/types'

import type { IPendingActionsCategoryActionsGroup, IPendingActionWithOffering } from './types'

export const PENDING_ACTIONS_UNCATEGORIZED = 'General'

export const PENDING_ACTION_PRIORITIES: FinancialCockpitPendingActionPriority[] = [
  FinancialCockpitPendingActionPriority.High,
  FinancialCockpitPendingActionPriority.Medium,
  FinancialCockpitPendingActionPriority.Common,
]

export const PENDING_ACTION_PRIORITY_CLASS_NAMES = {
  [FinancialCockpitPendingActionPriority.High]: 'high',
  [FinancialCockpitPendingActionPriority.Medium]: 'medium',
  [FinancialCockpitPendingActionPriority.Common]: 'common',
}

export const getPendingActionsPriorityCounts = (actions: IFinancialCockpitPendingAction[]) =>
  actions.reduce(
    (counts, action) => {
      counts[action.ActionPriority] += 1
      return counts
    },
    {
      [FinancialCockpitPendingActionPriority.High]: 0,
      [FinancialCockpitPendingActionPriority.Medium]: 0,
      [FinancialCockpitPendingActionPriority.Common]: 0,
    }
  )

export const getPendingActionKey = (action: IFinancialCockpitPendingAction, offering: string) =>
  [offering, action.ActionOwner, action.ActionType, action.ActionTitle, action.ActionOrder].join(
    ':'
  )

export const groupPendingActionsByCategory = (
  actions: IPendingActionWithOffering[]
): IPendingActionsCategoryActionsGroup[] =>
  actions.reduce<IPendingActionsCategoryActionsGroup[]>((categoryGroups, action) => {
    const category = action.ActionCategory || PENDING_ACTIONS_UNCATEGORIZED
    const categoryGroup = categoryGroups.find((group) => group.category === category)

    if (categoryGroup) {
      categoryGroup.actions.push(action)
    } else {
      categoryGroups.push({ category, actions: [action] })
    }

    return categoryGroups
  }, [])
